import { formatMoney as shopifyFormatMoney } from '@shopify/theme-currency'

const settings = window.GM_STATE
const CENTS_IN_DOLLAR = 100

const formatMoney = function (cents, format = settings.shopify.moneyFormat) {
  return shopifyFormatMoney(cents, format)
}

const formatRangePrice = (values) => values && values.map(item => formatMoney(item * CENTS_IN_DOLLAR)).join(' - ')

function convertPrice(price) {
  if (typeof price === 'string') {
    return parseFloat(price)
  } else if (typeof price === 'number') {
    return price
  } else {
    throw new Error('Price must be a string or a number')
  }
}

function getPrice(price) {
  return price ? convertPrice(price) * CENTS_IN_DOLLAR : 0
}

const getDefaultImage = (img) => {
  return (Array.isArray(img) && img.length === 0) || !img ? GM_STATE.shopify.defaultImage : img
}

const getSingleGraphQLId = (id, type) => `gid://shopify/${type}/${id}`

const getMultipleGraphQLIds = (ids, type) => {
  if (ids.length === 0) return []

  return ids.map((id) => getSingleGraphQLId(id, type))
}

const getIdByGraphQlId = (gid) => {
  if (typeof gid !== 'string') {
    // eslint-disable-next-line no-console
    console.error('Invalid argument: gid must be a string')

    return null
  }

  const arr = gid.split('/')

  if (arr.length === 0) {
    // eslint-disable-next-line no-console
    console.error('Invalid argument: gid must contain "/"')

    return null
  }

  return +arr[arr.length - 1]
}

export {
  formatMoney,
  formatRangePrice,
  getPrice,
  getDefaultImage,
  getMultipleGraphQLIds,
  getSingleGraphQLId,
  getIdByGraphQlId
}
